import React from "react";
import logo from "../assets/img/kolomaka_logo_crop.png";

type BrandLogoProps = {
  className?: string;
  imageClassName?: string;
};

export const BrandLogo: React.FC<BrandLogoProps> = ({
  className = "",
  imageClassName = "h-12 w-auto rounded-2xl object-contain",
}) => {
  return (
    <div className={className}>
      <img
        alt="Kolomaka Cleaning logo"
        className={imageClassName}
        src={logo}
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />
    </div>
  );
};
